module.exports = __webpack_public_path__ + "static/media/operations-feature-tile-icon-02.8f6336dc.svg";